export class Orgao {
  public id!: number | null;
  public ativo!: boolean;
  public nome!: string;
  public codigoExterno!: number;
  public codigoAverbacao!: number;
  public idEmpregador!: number;
}